import { useTranslation } from 'react-i18next';
import { Tabs } from '@anytag/shared-atoms';
import { cn } from '@anytag/shared-utils';

export const InfluencersTabs = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <Tabs
      className={cn('px-4', className)}
      options={[
        {
          end: false,
          label: t('General.Select Influencers'),
          to: '/influencers/search'
        },
        {
          end: false,
          label: t('Propose Influencers'),
          to: '/influencers/proposal'
        }
      ]}
    />
  );
};
